/*

Mueller Style Sheet color palette:

Source:  https://mueller-inc.atlassian.net/wiki/spaces/SG/pages/396485/Logos?preview=/396485/396448/Mueller%20Brand%20Standards.pdf

Red:        #C8102E  $md primary color
Dark Gray:  #75787B  $md secondary color
Cranberry:  #710002
Cyan:       #7ACFD6
Light Gray: #B5ABA2
Tan:        #ECD8BF

WARNING: The given color "#75787B" is not a valid material design color. 
Please set the "$md-data-table-contextual-fallback-color" or disable the
"$md-colors-warn-md" variable to ignore this message (not recommended because of losing styling). 
See https://react-md.mlaursen.com/customization/colors?tab=1#variable-md-colors-warn-md for more information.

Website colors:
Card Title: whitesmoke on light gray background (#B5ABA2)

var(--tertiary-color): #FFF;
var(--fourth-color): rgba(0,0,0,0.87);
$NOMAD: #B5ABA2;
var(--tertiary-color): #F5F5F5;
var( --primary-color-darker): var( --primary-color-darker);
$CRIMSON:  #c8102e;
var(--secondary-color-darker): #75787b;
var(--secondary-color): #babcbd;
$LARIOJA: #c6c610;
$SILVERCHALICE: #a0a0a0;
$GALLERY: #eeeeee;

*/
export const fontColor = {
  primary: "#C8102E",
  secondary: "#75787B",
  error: "var( --primary-color-darker)",
  disabled: "#a0a0a0",
  pageHeader: "#fff",
  sectionHeader: "#C8102E",
  cardHeader: "#fff"
};

export const backgroundColor = {
  button: "#C8102E",
  icon: "#fff",
  pageHeader: "#eeeeee",
  sectionHeader: "#eeeeee",
  section: "#f5f5f5",
  cardHeader: "#babcbd",
  page: "#fff"
};

export const assignmentToolColors = {
  countyBorderColor: "#777",
  zipBorderColor: "#F00",
};